import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import type { CmsApiSearchLanding } from '#/modules/cms/api/types/CmsApiSearchLanding';

type Args = {
  content: CmsApiDocument | CmsApiSearchLanding;
};

export function getContentUrlByLocale({
  content,
}: Args): Record<string, string> {
  return content.translations.reduce(
    (acc, cur) => Object.assign(acc, { [cur.locale]: `/${cur.url}` }),
    content.type === 'SEARCH_LANDING_PAGE'
      ? {}
      : { [content.locale]: `/${content.url}` },
  );
}
